export default __webpack_public_path__ + "images/KB.aceeb5d.png";